module.exports = __webpack_public_path__ + "img/btn_AppStoredark.caab4ed4.svg";